import { AlertTriangle, TrendingUp, FileText } from "lucide-react";

const stats = [
  {
    icon: FileText,
    stat: "4 frameworks. One exposure.",
    label: "FSANZ's Food Standards Code governs health claims on functional foods and nutraceuticals — a separate compliance obligation to the TGA that most brands manage inconsistently, or not at all. CompliGUARD covers both.",
  },
  {
    icon: AlertTriangle,
    stat: "$2.3M+",
    label: "Over the past two years, the TGA has issued 165+ infringement notices and more than $2.3 million in penalties for unlawful advertising of therapeutic goods. Serious breaches can escalate to Federal Court enforcement actions.",
  },
  {
    icon: TrendingUp,
    stat: "13,700+",
    label: "In the 2024–25 financial year, the TGA requested removal of more than 13,700 unlawful advertisements from digital platforms. Digital health advertising is now actively monitored and enforced.",
  },
];

const Problem = () => {
  return (
    <section className="py-16 sm:py-28 bg-background">
      <div className="container max-w-6xl px-5 sm:px-6 lg:px-8">
        <p className="section-label mb-4 text-left">THE COMPLIANCE GAP</p>
        <div className="teal-rule mb-6 sm:mb-8" />

        <h2 className="text-2xl sm:text-4xl font-bold text-foreground mb-5 sm:mb-6 text-left max-w-3xl">
          Health brands are marketing faster than their compliance process can keep up with.
        </h2>

        <div className="text-text-body text-base sm:text-lg mb-10 sm:mb-16 text-left max-w-3xl leading-relaxed space-y-4">
          <p>
            Social posts go live without a review trail. Campaigns launch before a full
            compliance review has occurred. And when the TGA, FSANZ or the ACCC come knocking, most brands
            are at risk.
          </p>
          <p>
            The problem isn't that brands don't care about compliance. They do. The problem is that the infrastructure available to them was built for a different era. Per-review consulting works for a product label or a TV commercial. It doesn't work for a social media calendar, a Google Ads campaign, or an influencer brief that needs to go live in 48 hours.
          </p>
          <p>
            It's not a competence problem. It's an infrastructure problem — and no amount of internal training fixes it. Compliance knowledge walks out the door every time someone resigns.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          {stats.map((item) => (
            <div
              key={item.stat}
              className="bg-card p-6 sm:p-8 border border-border card-accent-left rounded-sm text-left shadow-[0_4px_16px_rgba(11,31,53,0.08)] card-hover"
            >
              <item.icon className="h-12 w-12 sm:h-16 sm:w-16 text-destructive mb-3 sm:mb-4 opacity-90" />
              <div className="text-2xl sm:text-3xl font-extrabold text-foreground mb-2">
                {item.stat}
              </div>
              <p className="text-text-caption text-sm leading-relaxed">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Problem;
